import React, { useState, useEffect } from 'react';
import styles from './BonusCards.module.css';

/**
 * BonusCards Component
 * Additional promotion cards for logged-in users
 */
const BonusCards = () => {
  const [country, setCountry] = useState('');
  const [promotionCards, setPromotionCards] = useState([]);

  useEffect(() => {
    const checkCountry = () => {
      const userCountry = localStorage.getItem('country') || '';
      setCountry(userCountry);

      const cards = [
        {
          bonusText: '100% Bonus +',
          subText: '100 Free Bet In Casino',
          status: 'In Progress',
          image:
            userCountry === 'MV'
              ? '/assets/images/promotions/wheel.webp'
              : '/assets/images/promotions/wheel.webp',
          background:
            'linear-gradient(240deg, rgba(255, 168, 37, 0.4) -16.41%, rgba(255, 220, 37, 0) 71.96%);',
        },
        {
          bonusText: '100% Bonus +',
          subText: '5 Free Bet In Sports',
          status: 'In Progress',
          image:
            userCountry === 'MV'
              ? '/assets/images/promotions/cup-1.webp'
              : '/assets/images/promotions/cup-1.webp',
          background:
            'linear-gradient(240deg, rgba(64, 163, 106, 0.8) -16.41%, rgba(36, 220, 114, 0) 71.96%);',
        },
      ];

      setPromotionCards(cards);
    };

    checkCountry();

    // Listen for changes in localStorage
    const handleStorageChange = (e) => {
      if (e.key === 'country') {
        checkCountry();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <div className={styles.grid}>
      {promotionCards.map((card, index) => (
        <div
          key={index}
          className={styles.card}
          style={{ background: card.background }}
        >
          <div className={styles.contentWrapper}>
            <h2 className={styles.bonusText}>{card.bonusText}</h2>
            <p className={styles.subText}>{card.subText}</p>
          </div>
          <img
            src={card.image}
            alt={`${card.subText} icon`}
            className={styles.image}
          />
        </div>
      ))}
    </div>
  );
};

export default BonusCards;
